<template>
  <div class="sidebar dinline-block vtop">
    <div class="st fs30 bg-red twhite">{{menuList.name}}</div>
    <div class="adiv fs16 tleft">
      <router-link v-for="(child,index) in menuList.children" :key="index"
                   :to="{path:child.to,query:{id:index,pid:pid}}"
                   :class="{active:index==$route.query.id}"
                   class="bborder dblock">{{child.name}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Left",
  props:[
    'pid'
  ],
  data(){
    return {
    }
  },
  created() {
  },
  computed:{
    menuList:function () {
      return this.$params.column[this.pid]
    }
  }
}
</script>

<style scoped>
.active{
  font-weight: bold;
  background: url(../../assets/images/cn1.png) no-repeat 27px -1213px;
}
</style>



// WEBPACK FOOTER //
// src/components/un_index/Left.vue